
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keywords",
      function () {
        return require("private-next-pages/keywords.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/keywords"])
      });
    }
  